import { render, staticRenderFns } from "./banniandu.vue?vue&type=template&id=64ca1f1a&scoped=true&"
import script from "./banniandu.vue?vue&type=script&lang=js&"
export * from "./banniandu.vue?vue&type=script&lang=js&"
import style0 from "./banniandu.vue?vue&type=style&index=0&id=64ca1f1a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ca1f1a",
  null
  
)

export default component.exports